

































































































































































































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { Workspace, Summary } from "@/entities";
import { AppConstants as _app } from "@/shared/app.constants.ts";
import { VueEditor } from "vue2-editor";
import NotificationMessageComponent from "@/components/common/Notifiaction/NotificationMessage.vue";
import * as _ from "lodash";

const namespace: string = "application";
@Component({
  components: {
    VueEditor,
    NotificationMessageComponent,
  },
})
export default class WorkflowButtonsComponent extends Vue {
  @Prop() workFlowItems: any;
  @Prop() hideComment: boolean;
  @Prop() switchable: boolean;
  @Prop() entity: any;
  @Prop() preAction: any;
  // added new prop transaction id since the workflow instance doesn't have the transaction id
  @Prop() transactionId: number;
  @Prop({ default: 0 }) updateKey!: any;
  @Action("showNotification", { namespace }) showNotification: any;
  @Action("validate", { namespace }) validate: any;
  @Action("rollbackWorkflow", { namespace }) rollbackWorkflow: any;

  actions = _app.actions;
  subjects = _app.subjects;

  isReturnAction: boolean = false;
  wCommentDialog: boolean = false;
  showBtns = false;
  selectedItem: any = {};
  displayNotification: boolean = false;
  recipient: string;
  comments: string;
  template: string;
  header: string = " ";
  logId: number = 0;
  rollbackReason: string = "";
  showComments: boolean = false;
  commentDialog: boolean = false;
  subject: string;
  notify: boolean = true;
  localUpdateKey = this.updateKey;
  disabledButtons: any = {};
  

  mounted() {
    //@ts-ignore
    // console.log(this.$can(this.actions.manage, this.subjects.feedback));
    this.header = this.$t("Add comment");    
  }

  notification(e) {
    this.selectedItem.Comments = e.body;
    this.selectedItem.Subject = e.subject;
    this.notify = e.notify;
    this.submit();
  }

  get actionButtons() { 
    return this.workFlowItems.ActionItems || [];
  }
  
  get rollBackJourney() {
    let workflowInfo = this.workFlowItems;
    let item: any = {};
    let currentStep = this.workFlowItems.CurrentStep.WorkFlowStepId;    
    if (workflowInfo && workflowInfo.Journey) {      
      item = workflowInfo.Journey.find((x) => x.StepId === currentStep); 
    }    
   
    return item;
  }

  get currentStep() {
    return this.workFlowItems.CurrentStep || {};
  }

  get setWidth() {
    return this.displayNotification ? "70%" : "700";
  }

  toggleWFBtns() {
    this.showBtns = !this.showBtns;
  }

  /** Return to lead partner */
  returnToLP() {
    this.workFlowItems.CurrentStep.ReturnStatus = 1;
    this.workFlowItems.CurrentStep.ReturnComments = this.selectedItem.Comments;
    this.workFlowItems.CurrentStep.ReturnSubject = this.selectedItem.Subject;
    this.workFlowItems.CurrentStep.notify = this.selectedItem.notify;
    this.$services.revision
      .returnToLP(this.workFlowItems.CurrentStep)
      .then((resp) => {
        if (resp && resp.data && resp.data.Result == "OK") {
          this.showNotification({
            text: "Returned successfully",
            color: "success",
          });
          this.$emit("return", resp.data);
        } else {
          this.workFlowItems.CurrentStep.ReturnStatus = 1;
          this.showNotification({
            text: "Error occured while saving the record",
            color: "error",
          });
        }
        this.enableAllButtons();
      });
  }

  /** submit back to admin */
  submitBack() {
    this.$set(this.disabledButtons, 'FinalSubmit', true);
    this.workFlowItems.CurrentStep.ReturnStatus = 0;
    this.workFlowItems.CurrentStep.notify = this.notify;
    /** validate the data */
    this.$services.revision
      .validateOnSubmit(
        this.workFlowItems.CurrentStep.TransactionId,
        this.workFlowItems.CurrentStep.WorkFlowStepId,
        {}
      )
      .then((resp) => {
        if (resp.status >= 200 && resp.status < 300) {
          if (resp.data && resp.data.length > 0) {
            this.workFlowItems.CurrentStep.ReturnStatus = 1;
            this.$emit("validationError", resp.data);
            this.enableAllButtons();
          } else {
            // if valid, then submit the data
            this.$services.revision
              .submit(this.workFlowItems.CurrentStep)
              .then((resp) => {
                if (resp && resp.data && resp.data.Result == "OK") {
                  this.showNotification({
                    text: "Submitted successfully",
                    color: "success",
                  });
                  this.$emit("submit", resp.data);
                } else {
                  this.workFlowItems.CurrentStep.ReturnStatus = 1;
                  let errMsg =
                    resp.data.Message ||
                    "Error occured while submitting the record";

                  this.showNotification({
                    text: errMsg,
                    color: "error",
                  });
                }
                this.enableAllButtons();
              });
          }
        } else {
          this.workFlowItems.CurrentStep.ReturnStatus = 1;
          this.showNotification({
            text: "Error occured while submitting the record",
            color: "error",
          });
          this.enableAllButtons();
        }
      });
  }

  /** show dialog */
  showDialog(isReturnAction, item = null) {
    this.enableAllButtons();
    this.isReturnAction = isReturnAction;
    // Checks whether the action is return to LP or not
    if (isReturnAction) {
      if (this.hideComment) this.returnToLP();
      else {
        this.wCommentDialog = true;
        this.displayNotification = true;

        if (item.Recipient) {
          this.recipient = item.Recipient;
        }

        if (item.ReturnComments) {
          this.template = item.ReturnComments;
        }

        if (item.ReturnSubject) {
          this.subject = item.ReturnSubject;
        }

        this.selectedItem = item;
      }
    } else {
      if (item.AllowCustomMessage && item.AllowCustomMessage == true) {
        this.displayNotification = true;
        this.header = item.Action
          ? `${this.$t("Notification")}: ${this.$t(item.Action)}`
          : `${this.$t("Add comment")}`;
      }
      if (item.Recipient) {
        this.recipient = item.Recipient;
      }
      if (item.Template) {
        this.template = item.Template;
      }
      if (item.Subject) {
        this.subject = item.Subject;
      }
      this.selectedItem = item;
      // check for pre-action exists (save the unsaved data..)
      if (this.preAction) {
        this.preAction().then((result) => {
          // Validate the workflow only if preValidation returns no errors
          if (!result || !result.validationErrors || result.validationErrors.length === 0)
            this.validateWorkflow(item);
        });
      } else {
        this.validateWorkflow(item);
      }
    }
  }

  showRollbackDialog(id) {
    this.enableAllButtons();       
    this.logId = id;
    this.rollbackReason = "";
    this.commentDialog = true;
    this.$set(this.disabledButtons, 'Rollback', true);
  }

  rollback() {
    this.$set(this.disabledButtons, 'FinalSubmit', true);
    let item: any = {};
    item.LogId = this.logId;
    item.Reason = this.rollbackReason;
    let message = this.$services.format.personalizeString(
      `${this.$t("isRequired")}`,
      ["Comment"]
    );
    if (!item.Reason) {
      this.showNotification({ text: message, isHtml: false, color: "error" });
      this.enableAllButtons();
    } else {      
      this.rollbackWorkflow(item).then(res => {
        this.commentDialog = false;
        this.rollbackReason = "";        
        this.$emit("rollback",item);
        this.enableAllButtons();
      });
    }
  }

  /** validate the workflow */
  validateWorkflow(item) {
    this.validate({
      transactionId: this.transactionId || item.Id,
      workflowStepId: item.StepId,
      entity: this.entity || {},
    }).then((vldMgs: any) => {
      if (vldMgs.length === 0) {
        this.$set(this.disabledButtons, item.Action, true);
        if (this.hideComment){this.submit();}
        else {this.wCommentDialog = true;}
      } else {
        this.$emit("validationError", vldMgs);
        this.enableAllButtons();
      }
    });
  }

  /** button action */
  submit() {
    this.$set(this.disabledButtons, 'FinalSubmit', true);
    this.selectedItem.notify = this.notify;
    if (this.isReturnAction) {
      this.returnToLP();
    } else {
      this.$emit("click", this.selectedItem);
    }
    this.displayNotification = false;
    this.isReturnAction = false;
    this.wCommentDialog = false;
    this.recipient = "";
    this.template = "";
    this.subject = "";
    this.header = `${this.$t("Add comment")}`;
    this.selectedItem = {};
  }

  /** close the dialog */
  close() {
    this.wCommentDialog = false;
    this.commentDialog = false;
    this.displayNotification = false;
    this.recipient = "";
    this.template = "";
    this.subject = "";
    this.header = `${this.$t("Add comment")}`;
    this.selectedItem = {};
    this.enableAllButtons();
  }

  /** Re-enable all buttons */
  enableAllButtons() {
      Object.keys(this.disabledButtons).forEach((key) => {
        this.$set(this.disabledButtons, key, false);
      });
  }

  @Watch("this.workFlowItems.ActionItems")
    onDataChange(value)
    {
      this.enableAllButtons();
    }
}
